import React from "react";
// import styles from "../assets/scss/Components/_component.module.scss";

import { Form } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

export const ShadowContainer = () => {
  return <div className={"ShadowContainer"}></div>;
};

export const BackButton = ({
  classes = "",
  isRelative = false,
  handleBackButton,
}) => {
  const navigate = useNavigate();

  const onClick = () => {
    if (handleBackButton) {
      handleBackButton();
    }
    else {
      navigate(-1)
    }
  }
  return (
    <div
      className={`${"BackButton cursor-pointer"} ${isRelative ? "relative" : ""} ${classes}`}
      onClick={onClick}
    >
      <IoIosArrowBack size={30} />
    </div>
  );
};

export const Input = ({
  type = "text",
  classes = "mt-1 mb-2",
  style = {},
  size = "lg",
  placeholder = "",
  value = "",
  disable = false,
  as = "input",
  name = "",
  rows = 1,
  onChange = () => { },
  checked = {},
  min = {},
}) => {
  return (
    <Form.Control
      name={name}
      size={size}
      className={`${"Input"} ${classes}`}
      placeholder={placeholder}
      type={type}
      value={value}
      as={as}
      rows={rows}
      min={min}
      disable={disable.toString()}
      onChange={onChange}
      checked={checked}
    />
  );
};

///#region 066 custom input

export const CustomInput = ({
  name = "",
  placeholder = "",
  classes = "mt-1 mb-2",
  type = "",
  autoFocus = false,
  onChange,
}) => {
  return (
    <Form.Control
      name={name}
      className={`${"Input"} ${classes}`}
      placeholder={placeholder}
      autoFocus={autoFocus}
      onChange={onChange}
      type={type}
    />
  );
};

export const Description = ({
  text = "",
  classes = "",
  onClick = () => { },
}) => {
  return (
    <p className={`${"Description"} ${classes}`} onClick={onClick}>
      {text}
    </p>
  );
};

export const CardDescription = ({ text = "", classes = "" }) => {
  return <p className={`${"Description"} ${classes} fs-10`}>{text}</p>;
};

export const Title = ({ text = "", classes = "" }) => {
  return <h1 className={`${"Header"} ${classes}`}>{text}</h1>;
};

export const SubTitle = ({ text = "", classes = "" }) => {
  return <h2 className={`${"SubTitle"} ${classes}`}>{text}</h2>;
};
export const CardTitle = ({ text = "", classes = "" }) => {
  return <h6 className={`${"CardTitle"} ${classes} `}>{text}</h6>;
};
export const CardMatchTitle = ({ text = "", classes = "" }) => {
  return <h6 className={`${"CardMatchTitle"} ${classes} mt-1 mb-1`}>{text}</h6>;
};

export const Button = ({
  text = "",
  classes = "",
  style = {},
  onClick = () => { },
  disabled = false,
  type = "",
  className,
}) => {
  return (
    <button
      className={`${"Button"} ${classes} ${className}`}
      style={style}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {text}
    </button>
  );
};

export const AddButton = ({
  text = "",
  classes = "",
  style = {},
  onClick = () => { },
  className,
}) => {
  return (
    <div
      className={`${"AddButton"} ${classes} ${className}`}
      style={style}
      onClick={onClick}
    >
      {text}
    </div>
  );
};

export const TextDivider = ({ text = "", classes = "" }) => {
  return <div className={`${"TextDivider"} ${classes}`}>{text}</div>;
};

export const UnorderedList = ({
  lists = [],
  classes = "",
  item_classes = "",
}) => {
  return (
    <ul className={`${"UL"} ${classes} fs-7`}>
      {lists.map((item, index) => (
        <li key={index} className={`${item_classes} mt-2 mb-2 fs-7`}>
          {item}
        </li>
      ))}
    </ul>
  );
};

export const Checbox = ({ label = "", classes = "", onChange, checked }) => {
  return (
    <Form.Check
      type="checkbox"
      className={`${"Checkbox"} ${classes}`}
      label={label}
      onChange={onChange}
      checked={checked}
    />
  );
};

export const InputOTP = ({ props }) => {
  return (
    <Form.Control
      {...props}
      type="text"
      className={`${"Input"} ${"InputOTP"}`}
      size="lg"
    />
  );
};

export const LiveBadge = ({ text = "Live", classes = "" }) => {
  return <span className={`${"LiveBadge"} ${classes}`}>{text}</span>;
};

export const Score = ({ text = "", classes = "" }) => {
  return <span className={`${"Score"} ${classes}`}>{text}</span>;
};

/*#region: Developer 66*/
const CustomSelect = ({
  name = "",
  options = [],
  placeholder = "",
  classes = "mt-1 mb-2",
  autoFocus = false,
  onChange,
}) => {
  return (
    <Form.Select
      name={name}
      className={`${"Select"} ${classes}`}
      aria-label={placeholder}
      autoFocus={autoFocus}
      onChange={onChange}
    >
      <option value="">{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  );
};
